import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { isDate } from 'src/app/services/util/utils';

@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {
  transform(startDate: Date, endDate: Date, defaultValue = ''): string {
    if (startDate && endDate) {
      let startDateInternal = startDate;
      if (!isDate(startDate)) {
        startDateInternal = new Date(startDate);
      }
      let endDateInternal = endDate;
      if (!isDate(endDate)) {
        endDateInternal = new Date(endDate);
      }
      const diff = startDateInternal.getTime() - endDateInternal.getTime();
      return moment.duration(diff, 'milliseconds').humanize();
    }
    return defaultValue;
  }
}
